// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.border[data-v-269f03b6]{\r\n\tposition:absolute;\r\n\tleft:0;\r\n\twidth:100%;\n}\n.border-top[data-v-269f03b6]{\r\n\tborder:none;\r\n\tborder-top: 1px dashed;\n}\n.border-top div[data-v-269f03b6]{\r\n\theight: 5px;\n}\n.border div[data-v-269f03b6]{\r\n\theight:5px;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
